import { fromPairs, is, map, pipe, replace, toPairs } from 'ramda';

const camelize = (str: string) =>
  replace(/_([a-z0-9])/g, (_, letter) => letter.toUpperCase(), str);

export const camelizeKeys = (obj: any): any => {
  if (is(Array, obj)) {
    return obj.map(camelizeKeys);
  } else if (is(Object, obj)) {
    return pipe(
      toPairs,
      map(([k, v]) => [camelize(k), camelizeKeys(v)]),
      fromPairs
    )(obj);
  }
  return obj;
};
